import { render } from "./Head.vue?vue&type=template&id=69654100&scoped=true&ts=true"
import script from "./Head.vue?vue&type=script&lang=ts"
export * from "./Head.vue?vue&type=script&lang=ts"

import "./Head.vue?vue&type=style&index=0&id=69654100&scoped=true&lang=css"

import exportComponent from "G:\\Storage\\VSCodeProjects\\MineMCPay\\minemcpay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69654100"]])

export default __exports__